import { Divider, GridLegacy, Typography } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { Control, FieldValues, useFieldArray, useFormContext } from "react-hook-form";
import { DiscountedProductsTable } from "../../../components/DiscountedProducts/DiscountedProductsTable.tsx";
import { FormAutocomplete } from "../../../components/Autocomplete/FormAutocomplete.tsx";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns.tsx";

// type PartialForm = {
//   discounted_products: Array<{
//     id: number;
//     key: string;
//     naam: string;
//     pivot: {
//       id: number;
//       is_active_in_jamezz: boolean;
//       option_group_id: number;
//       price: number | null;
//       sort_key: number | null;
//     };
//     prijs: number;
//     sortkey: number | null;
//   }>;
// };

type OptionGroupForm = {
  id: number;
  allOptionsCount: boolean;
  maxCount: number;
  options?: ProductForm[];
};
type ProductForm = {
  id: number;
  maxCount: number;
  optionGroups?: OptionGroupForm[];
};
type PartialForm = {
  discounted_products: ProductForm[];
};

export const PercentageOffProduct = () => {
  const { control, menukaartVestigingId, vestiging } = useFormContext();
  const { fields, append, replace, remove } = useFieldArray<Partial<PartialForm>, "discounted_products", "key">({
    control: control as Control<FieldValues>,
    name: "discounted_products",
    keyName: "key",
  });

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <Typography variant={"h5"}>
                <TranslationWrapper
                  tDefault={"Percentage off of a product"}
                  tKey={"voucherDef.percentage_off_product.PERCENTAGE_OFF_PRODUCT"}
                />
              </Typography>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Typography>
                <TranslationWrapper
                  tDefault={"This will give a PERCENTAGE discount on the SPECIFIED PRODUCT(S)."}
                  tKey={"voucherDefs.form.percentage_off_product.explanation"}
                />
              </Typography>
            </GridLegacy>

            <FormControlledInputTC
              name={"priceDiscountPercentage"}
              suffix={" %"}
              tDefault={"Price Discount Percentage"}
              tKey={"voucherDefs.form.algemeen.label.priceDiscountPercentage"}
              type={"number"}
            />

            <FormAutocomplete
              tDefault={"Voucherproduct (in cash desk / on ticket)"}
              tKey={"voucherDefs.form.algemeen.label.voucherProduct"}
              name={"freeProducts_JSON"}
              autcompleteProps={{
                menuSalesareaId: menukaartVestigingId,
                defaultFilters: {
                  vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId },
                  is_option: { field: "is_option", value: false },
                },
              }}
              value={(field) => JSON.parse(field.value ?? "[]").map((id) => String(id))}
              onChange={(field) => (value) => {
                field.onChange(JSON.stringify((value ?? []).map((item) => Number(item.id))));
              }}
            />
            <FormAutocomplete
              tDefault={"Product(s) to get this discount [~]"}
              tKey={"voucherDefs.form.algemeen.label.includedProducts"}
              name={"includedProducts_JSON"}
              autcompleteProps={{
                menuSalesareaId: menukaartVestigingId,
                defaultFilters: {
                  vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId },
                  is_option: { field: "is_option", value: false },
                },
              }}
              value={(field) => JSON.parse(field.value ?? "[]").map((id) => String(id))}
              onChange={(field) => (value) => {
                field.onChange(JSON.stringify((value ?? []).map((item) => Number(item.id))));
              }}
            />

            <FormControlledInputTC
              name={"maxChooseItems"}
              tDefault={"Maximum discounted items (0 = No limit)"}
              tKey={"voucherDefs.form.algemeen.label.maxChooseItems"}
              type={"number"}
            />
            <Divider sx={{ width: 1 }} />
            <FormFieldTwoColumns tKey={"discounted_products"} tDefault={"Configure discount per product/option-group"}>
              <DiscountedProductsTable
                discountedProducts={fields}
                onChange={(products) => replace(products)}
                salesAreaId={menukaartVestigingId}
                currency={vestiging.valuta}
                replace={replace}
                remove={remove}
              />
            </FormFieldTwoColumns>
            <Divider sx={{ width: 1 }} />

            <FormAutocomplete
              tKey={"voucherDefs.form.algemeen.label.onlyifProduct"}
              tDefault={"Only allow discount when these products are in Shopping Basket"}
              name={"onlyifProductsInBasket_JSON"}
              autcompleteProps={{
                menuSalesareaId: menukaartVestigingId,
                defaultFilters: {
                  vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId },
                  is_option: { field: "is_option", value: false },
                },
                enableSelectAll: true,
              }}
              value={(field) => JSON.parse(field.value ?? "[]").map((id) => String(id))}
              onChange={(field) => (value) => {
                field.onChange(JSON.stringify((value ?? []).map((item) => Number(item.id))));
              }}
            />

            <FormSwitchTC
              name={"allowOnEveryOnlyifProduct"}
              tDefault={"allowOnEveryOnlyifProduct"}
              tKey={"voucherDefs.form.algemeen.label.allowOnEveryOnlyifProduct"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
};

export default PercentageOffProduct;
